import localforage from 'localforage';
import { notifications } from '@mantine/notifications';

export const PERSISTED_ENTRY_TTL_MS = 24 * 60 * 60 * 1000;

export const drawingStore = localforage.createInstance({
  name: 'drawww',
  storeName: 'drawings',
});

export const draftStore = localforage.createInstance({
  name: 'drawww',
  storeName: 'drafts',
});

type PersistedRecord = { savedAt?: number } | null;

let persistenceUnavailable = false;

export const isPersistenceUnavailable = () => persistenceUnavailable;

// Notifies once per session: in private browsing every storage operation
// rejects, so callers report the first failure and skip further writes.
export const markPersistenceUnavailable = (error: unknown) => {
  if (persistenceUnavailable) return;
  persistenceUnavailable = true;
  console.warn('Local persistence is unavailable; auto-save is disabled:', error);
  notifications.show({
    title: 'Auto-save unavailable',
    message: "Your browser is blocking local storage, so unsent work can't be restored if you leave this page.",
    color: 'yellow',
  });
};

const sweepStore = async (store: typeof drawingStore) => {
  const now = Date.now();
  const staleKeys: string[] = [];
  await store.iterate<PersistedRecord, void>((value, key) => {
    if (!value || typeof value.savedAt !== 'number' || now - value.savedAt > PERSISTED_ENTRY_TTL_MS) {
      staleKeys.push(key);
    }
  });
  await Promise.all(staleKeys.map((key) => store.removeItem(key)));
};

// Same-key reads enforce the TTL, but entries for finished or abandoned games
// are never read again, so their payloads (including drawing background
// data-URLs) would accumulate until the browser purges the whole origin.
export const sweepStalePersistedEntries = async () => {
  try {
    await Promise.all([sweepStore(drawingStore), sweepStore(draftStore)]);
  } catch (error) {
    console.warn('Failed to sweep stale persisted entries:', error);
  }
};
